import axios from 'axios';
import {store, vesselStore} from "./main.js"

export class getData {
    periods = {
        'Last Month': 'month',
        'Last 3 Months': 'threemonths',
        'Last 6 Months': 'sixmonths',
        'Last year': 'twelvemonths'
    };

    constructor() {
        store.MyEvent.listen('config_loaded', () => {
            this.getRealAggrData();
        });
    }

    async getRealAggrData (period) {
        if (typeof period == 'undefined')
            period = 'Last Month';

        try {
            var query = this.periods[period],
                response = await axios.get(store.config.api_location+'/GetWiDEInternalData/' + query + '/subsystem').catch(function () {});

            if (typeof response != 'undefined' && response.status ==200)
                store.subSystemAggr = JSON.parse(response.data.data);

            response = await axios.get(store.config.api_location+'/GetWiDEInternalData/' + query + '/enginetype').catch(function () {});

            if (typeof response != 'undefined' && response.status ==200)
                store.engineAggr = JSON.parse(response.data.data);

            response = await axios.get(store.config.api_location+'/GetWiDEInternalData/' + query + '/customers').catch(function () {});

            if (typeof response != 'undefined' && response.status == 200) {
                var tmp = JSON.parse(response.data.data),
                    result = {};

                for (var i in tmp) {
                    if (Object.prototype.hasOwnProperty.call(tmp, i) && tmp[i].is_shipping == 1) {
                        result[i] = tmp[i];
                    }
                }

                store.companyAggr = result;
            }

            response = await axios.get(store.config.api_location + '/GetWiDEInternalData/GetVesselTickets/').catch(function () {
            });

            if (typeof response != 'undefined' && response.status == 200) {
                store.vesselTickets = response.data.data.vessels;
            }

            store.type=query;
        } catch (e) {
            // console.log(e);
        }
    }
}
